export const buildQueryParams = (params) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value) ? value.length > 0 : value)
      searchParams.append(key, value);
  });
  return searchParams.toString().replaceAll("%2C", ",");
};

export const commonParams = (params) => ({
  scope: params.scope,
  date: params.date,
  page: params.page,
  items_per_page: 50,
  managers: params.manager,
  assigned_branch_ids: params.subsidiary,
  domain_categories: params.jobCategory,
  domains: params.job,
  first_managers: params.start_at,
  worker_type: params.worker_type,
  mission_signed_by_ids: params.subsidiary,
});
